module.exports = __webpack_public_path__ + "img/bp_lp_top_bg.d20e7e4e.png";